import { applyMiddleware, createStore } from 'redux'
import thunk from 'redux-thunk'
import { combineReducers } from 'redux'
import apa from 'apa/reducers'
import customers from 'customers/reducers/customers'
import items from 'items/reducers/items'
import categories from 'catalog/reducers/categories'
import invoices from 'invoices/reducers/invoices'
import manuals from 'manuals/reducers'
import template from 'template/reducers'
import training from 'training/reducers'
import {apiMiddleware} from 'apa/middleware/api'

import { connectRouter } from 'connected-react-router'
import { createBrowserHistory } from 'history'
import { routerMiddleware } from 'connected-react-router'

export const history = createBrowserHistory()
const createStoreWithMiddleware = applyMiddleware(apiMiddleware, thunk, routerMiddleware(history))(createStore)
export const combinedReducer = combineReducers(
    {
        router: connectRouter(history),
        apa,
        customers,
        items,
        categories,
        invoices,
        manuals,
        template,
        training
    }
)
const store = createStoreWithMiddleware(combinedReducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())

export default store
